import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import InspectionHomePage from "../InspectionHome/InspectionHome";
import HomePage from "../Home/Home";

export const InspectionModule = () => {
  let { path } = useRouteMatch();

  return (
    
      <Switch>
        
   
         
        {/* <ProtectedRoute exact path={`${path}/inspection`}>
        <InspectionHomePage/>
        </ProtectedRoute>  */}
        <ProtectedRoute exact path={`${path}/:id(\\d+)`}>
          <InspectionHomePage />
        </ProtectedRoute>
        
        <Route>
          <NotFound />
        </Route>
      </Switch>
    
  );
};

export default InspectionModule;
